module.exports = __webpack_public_path__ + "img/logo_simdelivery.2a2c51e4.svg";